import bowser from "bowser/bundled";

class UserInfo {

  static platform = bowser.getParser(window.navigator.userAgent).parsedResult;

  static getInfo() {
    const isMobile = this.platform.platform.type !== "desktop";
    const isApp =  localStorage.getItem('ifs_platform') === 'cordova';

    return {
      platform: this.platform.os.name,
      browser: this.platform.browser.name,
      version: this.platform.browser.version,
      isMobile,
      isApp
    };
  }

}

export default UserInfo;
